import { Columns, React } from '@1337lawyers/design';

const PendingInvestorVerificationRequests = () => (
  <Columns>
    <div className="column is-10 is-offset-1">Investor Dashboard</div>
  </Columns>
);

export default PendingInvestorVerificationRequests;
